import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const LoadingContainer = styled(motion.div)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @keyframes blink {
    0% {
      opacity: 0.2;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
  }

  .svg circle {
    animation-name: blink;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    border-radius: 50%;
    font-size: 130px;
    color: #00aced;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }

  h3 {
    color: #7c6d89;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
  }
`;
const Loading = ({ title, colorsDot, showTitle }) => (
  <LoadingContainer
    key="loading"
    variants={{
      initial: {
        opacity: 0,
      },
      enter: {
        opacity: 1,
        transition: {
          duration: 0.3,
          delay: 0.2,
          when: 'beforeChildren',
        },
      },
      exit: {
        opacity: 0,
        transition: {
          duration: 0.5,
        },
      },
    }}
    initial="initial"
    animate="enter"
    exit="exit"
  >
    {showTitle ? <h3>{title}</h3> : null}
    <svg className="svg" width="70" height="26">
      <circle className="a" cx="9" cy="13" r="6" fill={colorsDot} />
      <circle className="b" cx="32" cy="13" r="6" fill={colorsDot} />
      <circle className="c" cx="55" cy="13" r="6" fill={colorsDot} />
    </svg>
  </LoadingContainer>
);

Loading.propTypes = {
  showTitle: PropTypes.bool,
  title: PropTypes.string,
  colorsDot: PropTypes.string,
};

Loading.defaultProps = {
  showTitle: true,
  title: 'Cargando',
  colorsDot: '#7c6d89',
};

export default Loading;
